import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';
import { getSession } from '../../../contexts/auth';
import EditPedido from '../Order/edit';
import { loadData as getConfig } from '../Order';

const OrderFrame = ({ num, emailDesc, handleClose, refuseModal }) => {

    const defaultBackend = process.env.REACT_APP_URL_PLATESYS

    const mode = localStorage.getItem('engine')

    const [link, setLink] = useState(`${defaultBackend}pedido/${num}`)
    const [config, setConfig] = useState({})

    useEffect(()=>{
        getConfig(setConfig, true, ()=>{})
    }, [])

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box>
                <p style={{ textWrap: 'wrap', color: '#d86600', fontWeight: 'bold' }}>Obs: {emailDesc}</p>
            </Box>
            {mode === 'ELEVOR' ?
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', flex: 1 }}>
                    <EditPedido
                        data={{ id: num }}
                        nextOrder={0}
                        handleClose={handleClose}
                        reloadData={() => { }}
                        configs={config.configs}
                        viewOnly={true}
                        refuseModal={refuseModal}
                    />
                </Box>
                :
                <Box sx={{ display: 'flex', justifyContent: 'center', height: '95%', height: '60rem' }}>
                    <iframe src={link} frameborder="0" width="100%" height="100%"></iframe>
                </Box>
            }


        </Box>
    )
}

export default OrderFrame;